import { IconButton } from "@mui/joy";
import useClose from "../../../hooks/useClose";

export default function CloseButtonSmall() {
  const close = useClose();
  return (
    <IconButton
      onClick={close}
      variant="plain"
      color="neutral"
      size="md"
      sx={{
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18"
          stroke="#20272B"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M18 18L6 6"
          stroke="#20272B"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </IconButton>
  );
}
